<!-- 销售市场查询 -->
<template>
  <div class="SalesMarketQuery">
    <app-breadcrumb/>
    <div class="page-container account">
      <div class="filter">
        <el-form :inline="true" :model="listQuery" size="mini">
          <!--经销商编号-->
          <el-form-item :label="$t('miMember.memberNo')+':'" >
            <el-input size="mini" v-model.trim="listQuery.memberNo" style="width:40%;" />{{$t(' ')+ $t('label.to')+$t(' ') }}<el-input size="mini" style="width:40%;" v-model.trim="listQuery.memberNoEnd"/>
          </el-form-item>
          <!--查询层数-->
          <el-form-item :label="$t('miMember.Layer')+':'">
            <el-input-number size="mini" v-model="listQuery.layer"/>
          </el-form-item>
          <el-form-item>
            <!--搜索-->
            <el-button type="primary" :loading="loading" plain icon="el-icon-search" @click="handleFilter">
              {{ $t('operation.button.search') }}
            </el-button>
          </el-form-item>
          <!--视图模式-->
          <el-form-item :label="$t('mi.ViewType')+':'">
            <el-select size="mini" v-model="listQuery.treeOrView" placeholder="" @change="viewData={}">
              <el-option
                  v-for="item in treeorview"
                  :key="item.code"
                  :label="$t(item.title)"
                  :value="item.code"/>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div v-show="listQuery.treeOrView==='View'" style="width: 100%;height: 550px;overflow: auto">
        <organization-chart
            v-loading="loading"
            v-show="Object.keys(viewData).length"
            style="height: 500px"
            :datasource="viewData"
            :zoom="true"
            :pan="true"
            :zoomin-limit="2"
            :zoomout-limit="0.5"
        >
          <template slot-scope="{ nodeData }">
            <div class="orgchartnnode" style="width: 120px;min-height: 100px;background: #FFE479;border: 1px solid #333333;line-height: 20px;border-radius: 10px">
              <p style="margin: 0;color: blue;text-decoration: underline;cursor: pointer"
                 @dblclick="getClickData(nodeData.memberNo)"
                 @click="copyData(nodeData.memberNo)">{{nodeData.memberNo }}
              </p>
              <p style="margin: 0">{{ $lt(initDict.cnmimembercardtype, nodeData.cardType) }}</p>
              <p style="margin: 0">{{ $lt(initDict.cnmemberlevel, nodeData.levelType) }}</p>
              <p style="margin: 0">{{ nodeData.name }}</p>
              <!-- 月新增人数 -->
<!--              <p style="margin: 0">{{ $t('Month_New_Number') }}: {{ nodeData.reNetMonthQty }}</p>-->
              <!-- 总累计人数 -->
<!--              <p style="margin: 0">{{ $t('Amount.to_Number') }}: {{ nodeData.reNetQty }}</p>-->
            </div>
          </template>
        </organization-chart>
      </div>
      <div v-show="listQuery.treeOrView==='Tree'" style="width: 100%;height: 550px;overflow: auto">
        <!--经销商网络全部展开-->
        {{ $t('miMember.Network.allOpenOrClose') }}
        <!--展开-->
        <el-button size="mini" :loading="loading" @click="setAllExpand(true)">{{ $t('miMember.Network.Open') }}</el-button>
        <!--折叠-->
        <el-button size="mini" :loading="loading" @click="setAllExpand(false)">{{ $t('miMember.Network.Close') }}</el-button>
        <el-tree
            class="mytree"
            ref="tree"
            v-show="Object.keys(viewData).length"
            v-loading="loading"
            :indent="16"
            :data="[viewData]"
            :props="defaultProps"
            node-key="memberNo"
            :expand-on-click-node="false"
        >
          <span slot-scope="scope" class="custom-tree-node">
            <span>
              <i :class="scope.data.children ? scope.data.children.length ? 'el-icon-s-custom': 'el-icon-user' : 'el-icon-user'"/>
            </span>
            <span>[<span class="pred">{{ scope.data.memberNo }}</span>]</span> -
            <span>[<span class="pred">{{ scope.data.name }}</span>]</span> -
            <span>[<span class="pred">{{ $lt(initDict.cnmimembercardtype, scope.data.cardType) }}</span>]</span> -
            <span>[<span class="pred">{{ $lt(initDict.cnmemberlevel, scope.data.levelType) }}</span>]</span> -
            <!-- 注册日期 -->
            <span>[<span class="pred">{{ scope.data.registerDate }}</span>]</span>-
            <!-- 层数  -->
            <span>[<span class="pred">{{ scope.data.recommendLayer }}</span>]</span>
          </span>
        </el-tree>
      </div>
    </div>
  </div>
</template>
<script>
import OrganizationChart from 'vue-organization-chart'
import 'vue-organization-chart/dist/orgchart.css'
import { SaleNewWorks } from "@/api/ay-personal-center/personalcenter"
import { mapGetters } from "vuex"

export default {
  name: "SalesMarketQuery",
  components: {OrganizationChart},
  data() {
    return {
      loading: false,
      viewData: {},
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      listQuery: {
        treeOrView: 'View',
        layer: 3,
      },
      initDict: {
        treeorview: 'treeorview',
        yesno: 'yesno',
        cnmimembercardtype: 'cn.mimember.cardtype',
        cnmemberlevel: 'cn.member.level',
      }
    }
  },
  computed: {
    ...mapGetters([
      'isAgent',
    ]),
    treeorview() {
      return this.$ll(this.initDict.treeorview)
    },
    yesno() {
      return this.$ll(this.initDict.yesno)
    },
    cnmimembercardtype() {
      return this.$ll(this.initDict.cnmimembercardtype)
    },
    cnmemberlevel() {
      return this.$ll(this.initDict.cnmemberlevel)
    },
  },
  methods: {
    handleFilter() {
      if (!this.listQuery.memberNo) {
        this.$message({
            title: '',
            message: this.$t('requied.input.memberNo'),
            type: 'warning'
          })
        return false
      }else {
        this.loading = true
      SaleNewWorks({...this.listQuery}).then(res => {
        this.loading = false
        this.viewData = res.data.data
      }).catch(err => {
        this.loading = false
        console.warn(err)
      })
      }

    },
    // handleFilter2() {
    //   if (!this.listQuery.memberNo) {
    //     return false
    //   }
    //   if (!this.viewData.recommendNo) {
    //     return false
    //   }
    //   this.loading = true
    //   SaleNewWorks({
    //     ...this.listQuery,
    //     memberNo: this.viewData.recommendNo,
    //     direction: 1
    //   }).then(res => {
    //     this.loading = false
    //     this.viewData = res.data
    //   }).catch(err => {
    //     this.loading = false
    //     console.warn(err)
    //   })
    // },
    copyData(memberNo) {
      const input = document.createElement('input');
      input.setAttribute('readonly', 'readonly')
      input.setAttribute('value', memberNo)
      document.body.appendChild(input)
      input.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
        console.log('复制成功')
      }
      document.body.removeChild(input);
    },
    getClickData(memberNo) {
      this.loading = true
      SaleNewWorks({...this.listQuery, memberNo: memberNo}).then(res => {
        this.loading = false
        this.viewData = res.data.data
      }).catch(err => {
        this.loading = false
        console.warn(err)
      })
    },
    setAllExpand(state) {
      const nodes = this.$refs.tree.store.nodesMap
      for (const i in nodes) {
        nodes[i].expanded = state
        this.$set(nodes[i], 'expanded', state)
      }
    },
  }
}
</script>
<style scoped lang="scss">
::v-deep {
  .el-tree {
    width: 100%;
    height: 500px;
    overflow: auto;
    margin-top: 10px;
  }

  .el-tree > .el-tree-node {
    display: inline-block;
    min-width: 100%;
  }
}

::v-deep div.el-tree-node__content {
  padding-left: 0 !important;
}

.mytree ::v-deep {
  .el-tree > .el-tree-node:after {
    border-top: none;
  }

  .el-tree-node {
    position: relative;
    padding-left: 16px;
  }

  .el-tree-node__expand-icon.is-leaf {
    width: 10px;
    height: 0;
    position: relative;
    top: -7px;
    margin-right: 1px;
    border-bottom: 1px dashed #4386c6;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node :last-child:before {
    height: 38px;
  }

  .el-tree > .el-tree-node:before {
    border-left: none;
  }

  .el-tree > .el-tree-node:after {
    border-top: none;
  }

  .el-tree-node:before {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  .el-tree-node:after {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  .el-tree-node:before {
    border-left: 1px dashed #4386c6;
    bottom: 0;
    height: 100%;
    top: -26px;
    width: 1px;
  }

  .el-tree-node:after {
    border-top: 1px dashed #4386c6;
    height: 20px;
    top: 12px;
    width: 24px;
  }

  .el-tree {
    width: 100%;
    overflow: scroll;
    overflow-y: hidden;
  }

  .el-tree > .el-tree-node {
    display: inline-block;
    min-width: 80%;
  }
}
</style>
